import FieldTitle from '../Forms/FieldTitle';
import Split from '../Shared/Split';
import classNames from 'classnames';
import { Button, Col, Row } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { actions } from '../../context';
import { groupedStatesProvinces, states, canadaProvinces } from '../Static/StatesProvinces';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { emptyGuid } from '../Shared/TextHelpers';

const otherKey = 'Other';
const formColClass = 'px-2 py-1';
const lgColSize = 6;
const mdColSize = 12;
//  TODO: more refactoring needed, this is extremely slow but it works
const EditPractice = () => {
    const dispatch = useDispatch();

    const goToWorkflowNextStep = () =>
        dispatch(
            actions.practiceWorkflow.setWorkflowStatus({
                loading: false,
                searchingPractices: false,
                editingPractice: false,
                editingRelations: true,
            })
        );

    const practice = useSelector((state) => state.practiceWorkflow.workflowPractice, shallowEqual);
    const isOpen = useSelector((state) => state.practiceWorkflow.workFlowStatus.editingPractice);

    const [groups, setGroups] = useState([]);
    const [pimses, setPimses] = useState([]);
    const [otherPims, setOtherPims] = useState([]);
    const [supportedPims, setSupportedPims] = useState([]);
    const [unsupportedPims, setUnsupportedPims] = useState([]);

    const submit = async (vals) => {
        let valuesToSubmit = {
            ...vals,
            usingOtherPims: isUsingOther(vals),
        };
        dispatch(actions.practiceWorkflow.setWorkflowWorkingPractice(valuesToSubmit));
        goToWorkflowNextStep();
    };

    useEffect(() => {
        if (isOpen) {
            dispatch(actions.pims.getAllPims()).then((res) => {
                setPimses(res.data || []);
                setOtherPims(res.data.filter((p) => p.name === otherKey));
                setSupportedPims(
                    res.data.filter(
                        (p) => p.supportsConnectivity && p.name !== otherKey
                    )
                );
                setUnsupportedPims(
                    res.data.filter(
                        (p) => !p.supportsConnectivity && p.name !== otherKey
                    )
                );
            });
            dispatch(actions.groups.getAllGroups()).then((res) =>
                setGroups(res.data || [])
            );
        }
    }, [dispatch, isOpen]);

    const havePimsWithId = (id) => id && pimses.filter((x) => x.id === id).length > 0;

    const isUsingOther = (values) =>
        values &&
        havePimsWithId(values.pimsId) &&
        pimses.filter((x) => x.id === values.pimsId)[0].name === otherKey;

    const getCountryFromStateProvince = (stateProvinceValue) => {
        if (!stateProvinceValue) return null;
        
        const usState = states.find(s => s.value === stateProvinceValue);
        if (usState) return 'United States';
        
        const caProvince = canadaProvinces.find(p => p.value === stateProvinceValue);
        if (caProvince) return 'Canada';
        
        return null;
    };

    // TODO: refactor this form with a wrapper component to make more readable
    return (
        <Form
            initialValues={{ 
                ...practice,
                country: practice?.stateProvince ? getCountryFromStateProvince(practice.stateProvince) : null
            }}
            onSubmit={submit}
            render={({
                handleSubmit,
                form,
                values,
                pristine,
                submitting,
            }) => (
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Practice Name" required />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="name"
                                placeholder="Name"
                                required
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Phone Number" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="phone"
                                placeholder="Phone"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Street Address" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                placeholder="Address"
                                name="address"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="City" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="city"
                                placeholder="City"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="State / Province" required />
                            <Field
                                name="stateProvince"
                                component="select"
                                className="w-100 p-2 rounded border"
                                placeholder="State/Province"
                                defaultValue=""
                                required
                                onChange={(event, input) => {
                                    const selectedValue = event.target.value;
                                    const country = getCountryFromStateProvince(selectedValue);
                                    form.change('stateProvince', selectedValue);
                                    form.change('country', country);
                                }}>
                                <option value="" disabled>
                                    Select a region
                                </option>
                                <option />
                                {(groupedStatesProvinces || []).map(
                                    (g, x) => (
                                        <optgroup key={`${x}-${g.label}`} label={g.label}>
                                            {g.options.map((o, y) => (
                                                <option
                                                    key={`${y}-${o.value}`}
                                                    value={o.value}>
                                                    {o.label}
                                                </option>
                                            ))}
                                        </optgroup>
                                    )
                                )}
                            </Field>
                        </Col>
                        {/* Hidden field to store the country value */}
                        <Field name="country" component="input" type="hidden" />
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Postal Code" required/>
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="postalCode"
                                placeholder="Code"
                                required
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Practice Contact" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="primaryContact"
                                placeholder="Contact"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Contact Email" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="email"
                                placeholder="Email"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Practice Website" />
                            <Field
                                className="w-100 p-2 rounded border"
                                component="input"
                                name="website"
                                placeholder="Website"
                            />
                        </Col>
                        <Col
                            lg={lgColSize}
                            md={mdColSize}
                            className={formColClass}>
                            <FieldTitle title="Pims" required/>
                            <Field
                                className="w-100 p-2 rounded border"
                                component="select"
                                defaultValue={''}
                                id="pims"
                                name="pimsId"
                                required>
                                <option value="" disabled>
                                    Pims
                                </option>
                                <optgroup label="Integration Supported">
                                    {supportedPims.map((p, x) => (
                                        <option key={p.id} value={p.id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </optgroup>
                                <optgroup label="Manually Supported">
                                    {unsupportedPims.map((p, x) => (
                                        <option key={p.id} value={p.id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </optgroup>
                                <optgroup label="Not Listed">
                                    {otherPims.map((p, x) => (
                                        <option key={p.id} value={p.id}>
                                            {p.name} (Specify)
                                        </option>
                                    ))}
                                </optgroup>
                            </Field>
                        </Col>
                        {isUsingOther(values) && (
                            <Col
                                lg={lgColSize}
                                md={mdColSize}
                                className={classNames(formColClass)}>
                                <FieldTitle title="Other Pims Name" />
                                <Field
                                    className="w-100 p-2 rounded border"
                                    component="input"
                                    name="otherPimsName"
                                    placeholder="Pims Name"
                                    required
                                />
                            </Col>
                        )}
                        <Col lg={lgColSize} md={mdColSize}>
                            <FieldTitle title="Practice Group" />
                            <Field
                                id="practiceGroup"
                                name="groupId"
                                component="select"
                                defaultValue=""
                                placeholder="Group"
                                className="w-100 p-2 rounded border">
                                <option value="" disabled>
                                    Group
                                </option>
                                <option />
                                {(groups || []).map((g, x) => (
                                    <option key={g.id} value={g.id}>
                                        {g.name}
                                    </option>
                                ))}
                            </Field>
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            className="mt-2">
                            <Split className="my-2">
                                <div>
                                    <Button
                                        color="danger"
                                        className="border mx-2"
                                        disabled={pristine}
                                        onClick={form.reset}>
                                        Clear
                                    </Button>
                                    {pristine &&
                                        practice?.id !== emptyGuid && (
                                            <Button
                                                onClick={goToWorkflowNextStep}
                                                color="primary"
                                                className="border">
                                                Skip
                                            </Button>
                                        )}
                                    {!pristine && (
                                        <Button
                                            color="primary"
                                            className="border"
                                            type="submit"
                                            disabled={submitting}>
                                            Next
                                        </Button>
                                    )}
                                </div>
                            </Split>
                        </Col>
                    </Row>
                </form>
            )}
        />
    );
};

export default EditPractice;
